
document.addEventListener('DOMContentLoaded', function() {
  console.log('Subscription widget initialization started');
  
  const radioButtons = document.querySelectorAll('.subscription-widget-vertical input[name="purchase-option"]');
  const oneTimeWrapper = document.querySelector('.one-time-wrapper');
  const subscribeWrapper = document.querySelector('.subscribe-wrapper');
  const sellingPlansContainer = document.querySelector('.selling-plans-container');
  const sellingPlanSelect = document.querySelector('.selling-plan-select');
  
  const productForm = document.querySelector('.product__buy-buttons form[action*="/cart/add"]');
  
  if (!productForm) {
    console.error('Product form not found');
    return;
  }

  let sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
  if (!sellingPlanInput) {
    sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    sellingPlanInput.value = '';
    productForm.appendChild(sellingPlanInput);
    console.log('Hidden selling_plan input created');
  }

  function updateSellingPlanValue() {
    const subscribeRadio = document.querySelector('#subscribe-save');
    if (subscribeRadio && subscribeRadio.checked && sellingPlanSelect && sellingPlanSelect.options.length > 0 && !sellingPlanSelect.disabled) {
      sellingPlanInput.value = sellingPlanSelect.value;
      console.log('Selling plan updated:', sellingPlanInput.value);
    } else {
      sellingPlanInput.value = '';
      console.log('Selling plan cleared (one-time purchase)');
    }
    setTimeout(() => {
      const input = document.querySelector('.input-variant-checked');
      if (input) {
        input.dispatchEvent(new Event('change', { 
          bubbles: true 
        }));
      }
    }, 100);
  }

  function handlePurchaseOptionChange() {
    document.querySelectorAll('.option-label').forEach(label => {
      label.style.backgroundColor = 'transparent';
    });
    
    oneTimeWrapper.classList.remove('active');
    if (subscribeWrapper) subscribeWrapper.classList.remove('active');
    
    this.nextElementSibling.style.backgroundColor = '#f9f9f9';
    
    if (this.value === 'subscribe' && subscribeWrapper) {
      subscribeWrapper.classList.add('active');
       oneTimeWrapper.classList.remove('active');
      if (sellingPlansContainer) sellingPlansContainer.style.display = 'block';
      updateSellingPlanValue();
    } else {
      oneTimeWrapper.classList.add('active');
      if (sellingPlansContainer) sellingPlansContainer.style.display = 'none';
      updateSellingPlanValue();
    }
  }

  radioButtons.forEach(radio => {
    radio.addEventListener('change', handlePurchaseOptionChange);
  });

  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener('change', function() {
      if (document.querySelector('#subscribe-save')?.checked) {
        updateSellingPlanValue();
      }
    });
  }

  const oneTimeRadio = document.querySelector('#one-time-purchase');
  if (oneTimeRadio && oneTimeRadio.nextElementSibling) {
    oneTimeRadio.nextElementSibling.style.backgroundColor = '#f9f9f9';
  }

  if (sellingPlanSelect && sellingPlanSelect.options.length === 0) {
    console.log('No subscription plans available');
    const noPlansOption = document.createElement('option');
    noPlansOption.value = '';
    noPlansOption.textContent = 'No subscription plans available';
    sellingPlanSelect.appendChild(noPlansOption);
    sellingPlanSelect.disabled = true;
  }

  productForm.addEventListener('submit', function(e) {
    updateSellingPlanValue();
    console.log('Form submitted with selling_plan:', sellingPlanInput.value);
  });

  console.log('Subscription widget initialization completed');
});

